import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { HaldorBlockConsumer, SkolonBlock } from '@haldor/ui';
import AssignmentBlock from './Blocks/AssignmentBlock';
import FileBlock from './Blocks/FileBlock';
import LinksBlock from './Blocks/LinksBlock';
var BlockConsumer = /*#__PURE__*/function (_Component) {
  function BlockConsumer() {
    _classCallCheck(this, BlockConsumer);
    return _callSuper(this, BlockConsumer, arguments);
  }
  _inherits(BlockConsumer, _Component);
  return _createClass(BlockConsumer, [{
    key: "render",
    value: function render() {
      var plugins = [AssignmentBlock, FileBlock, LinksBlock, SkolonBlock];
      return /*#__PURE__*/React.createElement(HaldorBlockConsumer, _extends({
        plugins: plugins
      }, this.props));
    }
  }]);
}(Component);
export default BlockConsumer;